// extracted by mini-css-extract-plugin
module.exports = {"page_title":"PageTitle_page_title__fAIbR"};